const UserPreferenceApiUrls = {
  TZ_GET: `${process.env.REACT_APP_CARBON_FOOTPRINT_URL}/cal-cfc/tz-user-pref/current-user/get`,
  TZ_PUT: `${process.env.REACT_APP_CARBON_FOOTPRINT_URL}/cal-cfc/tz-user-pref/update`,
  TZ_OPTIONS_GET: `${process.env.REACT_APP_CARBON_FOOTPRINT_URL}/cal-cfc/tz-user-pref/timezone-option/get`,
};

export default UserPreferenceApiUrls

